import { render, staticRenderFns } from "./daTaokeOrderCenter.vue?vue&type=template&id=1f9252cc&scoped=true&"
import script from "./daTaokeOrderCenter.vue?vue&type=script&lang=js&"
export * from "./daTaokeOrderCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9252cc",
  null
  
)

component.options.__file = "daTaokeOrderCenter.vue"
export default component.exports